/**
 * BLOC PARAPHOTOS
 * Carousel de fond en fondu enchaîné avec Ken Burns, et remontée du panneau au scroll.
 */
jQuery(document).ready(function ($) {

    const DUREE_AFFICHAGE = 6    // secondes pendant lesquelles une photo reste à l'écran
    const DUREE_FONDU = 1.2      // secondes de fondu enchaîné
    const ZOOM = 1.08            // échelle atteinte en fin de Ken Burns

    const MONTEE_PANNEAU = 1.8   // course du panneau, en multiple de sa propre hauteur
    const LISSAGE = .8           // secondes de rattrapage du scroll sur la remontée

    const animationsReduites = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    $(".bloc_paraphotos").each(function () {
        const bloc = this
        const panneau = bloc.querySelector(".panneau")
        const photos = gsap.utils.toArray(bloc.querySelectorAll(".fond .photo"))

        /**
         * REMONTÉE DU PANNEAU
         *
         * L'amplitude est un multiple de la hauteur du panneau : il démarre donc
         * bien sous le bord bas du bloc, où l'overflow hidden le masque, puis il
         * monte jusqu'à sa place. Exprimer la course en multiple plutôt qu'en
         * pixels la fait s'adapter à la longueur du texte saisi.
         */
        if (panneau && !animationsReduites) {
            gsap.fromTo(panneau,
                {
                    y: function () {
                        return panneau.offsetHeight * MONTEE_PANNEAU
                    }
                },
                {
                    y: 0,
                    ease: "power2.out",
                    force3D: true,
                    scrollTrigger: {
                        trigger: bloc,
                        start: "top bottom",
                        end: "center center",
                        scrub: LISSAGE,
                        invalidateOnRefresh: true
                    }
                })
        }

        // moins de deux photos ou animations réduites : carousel statique
        if (photos.length < 2 || animationsReduites)
            return

        // état de départ : seule la première photo est visible
        gsap.set(photos, { autoAlpha: 0 })
        gsap.set(photos[0], { autoAlpha: 1 })

        const tl = gsap.timeline({ repeat: -1, paused: true })

        photos.forEach(function (photo, i) {
            const suivante = photos[(i + 1) % photos.length]
            const debut = i * DUREE_AFFICHAGE
            const fondu = debut + DUREE_AFFICHAGE

            // Ken Burns : couvre l'affichage de la photo, fondu de sortie compris
            tl.fromTo(photo.querySelector("img"),
                { scale: 1 },
                { scale: ZOOM, duration: DUREE_AFFICHAGE + DUREE_FONDU, ease: "none" },
                debut)

            // fondu enchaîné vers la suivante, avec remise à zéro de son zoom
            tl.to(photo, { autoAlpha: 0, duration: DUREE_FONDU, ease: "power1.inOut" }, fondu)
                .set(suivante.querySelector("img"), { scale: 1 }, fondu)
                .to(suivante, { autoAlpha: 1, duration: DUREE_FONDU, ease: "power1.inOut" }, fondu)
        })

        // la timeline ne tourne que quand le bloc est à l'écran
        scrollTrigger.create({
            trigger: bloc,
            start: "top bottom",
            end: "bottom top",
            onToggle: function (self) {
                self.isActive ? tl.play() : tl.pause()
            }
        })
    })

})
